import Box from "@amzn/meridian/esm/components/box";
import Text from "@amzn/meridian/esm/components/text";

/**
 * ErrorState - the load-failure state for a session tab's body, shared by Agenda and Action Items.
 * The message is supplied by the caller (each tab has its own copy), so only the presentation is
 * shared — that's what keeps the two tabs from drifting on spacing or text treatment.
 */
const ErrorState = ({ message }) => (
  <Box spacingInset="450 400 none 400">
    <Text type="b200" color="error">{message}</Text>
  </Box>
);

export default ErrorState;
